<template>
  <!-- :include="['index']" 缓存不需要刷新页面 -->
  <div id="app">

    <transition :name="transitionName">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import store from "@/store";
import api from '@/api/index';
export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      transitionName: ''
    };
  },
  computed: {

  },
  watch: {
    $route(to, from) {
      //如果to索引大于from索引,判断为前进状态,反之则为后退状态
      console.log(to, "to");
      if (to.meta.zIndex > from.meta.zIndex) {
        //设置动画名称
        this.transitionName = "slide-left";
      } else {
        this.transitionName = "slide-right";
      }
      if(to.meta.isLogin){
        this.getUserInfo()
      }
    }
  },
  created() { },
  async mounted() {
    if(window.location.hostname === 'www.wetrue.com.cn' || window.location.hostname === 'www.wetrue.com.net'){
        //禁止用户右键
        document.onkeydown = function (e) {
          if (e.keyCode == 123 || (e.ctrlKey && e.shiftKey && e.keyCode == 73)) {
            return false;
          }
        };
        document.addEventListener("contextmenu", function (e) {
          e.preventDefault();
        })
    }


    // 获取屏幕宽度高度
    const screenWidth = window.screen.width;
    if (screenWidth <= 1680) {
      //小屏
      store.commit("setScreenWidth", 'small');
    } else {
      store.commit("setScreenWidth", 'defalut');
    }
  },
  methods: {
   async getUserInfo(){
      //获取用户信息 
      await api.getUserInfo().then(ret => {
        if (ret.code == 200) {
          let info = { data: {} }
          info.data = ret.data
          sessionStorage.setItem("userInfo", JSON.stringify(ret.data));
          if (info.data.pcVipStatus == '1') {
            // 会员
            info.data.status = 'member'
            this.setStatus(info)
          } else {
            // 用户会员过期 清除登录状态
            var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
            // sessionStorage.clear()
            // if (keys) {
            //   for (var i = keys.length; i--;) {
            //     document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString();//清除当前域名下的,例如：m.kevis.com
            //     document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString();//清除当前域名下的，例如 .m.kevis.com
            //     document.cookie = keys[i] + '=0;path=/;domain=kevis.com;expires=' + new Date(0).toUTCString();//清除一级域名下的或指定的，例如 .kevis.com
            //   }
            // }
            // this.$router.replace('/login');
          }
        }
      })
    },
    setStatus(res) {
      // 登录成功
      sessionStorage.setItem("userInfo", JSON.stringify(res.data));
      store.commit("setUserInfo", res.data);
    },
  },
};
</script>

<style lang="less">
@import './styles/index.less';

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 200ms;
  position: absolute;
}

.slide-right-enter {
  opacity: 0;
  transform: translate3d(-10%, 0, 0);
}

.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(10%, 0, 0);
}

.slide-left-enter {
  opacity: 0;
  transform: translate3d(10%, 0, 0);
}

.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-10%, 0, 0);
}
</style>



// WEBPACK FOOTER //
// src/App.vue